import styled from "styled-components";
var SuggestionItem = styled.li.withConfig({
  displayName: "SuggestionItem",
  componentId: "sc-w8ebqc-0"
})(["padding:15px 10px;cursor:pointer;list-style-type:none;"]);
export default SuggestionItem;